module.exports = __webpack_public_path__ + "img/pssm_indicator3.62dbc120.webp";